import React from "react";

export const GenerationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <mask
        id="mask0_11788_10755"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect
          x="0.197144"
          y="0.949219"
          width="23.6057"
          height="23.6057"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_11788_10755)">
        <path
          d="M5.11595 19.6379H6.35673L16.4251 9.56961L15.1843 8.32883L5.11595 18.3972V19.6379ZM3.64059 21.1133V17.7844L16.6144 4.81625C16.7631 4.68117 16.9273 4.57683 17.1069 4.50323C17.2867 4.42946 17.4753 4.39258 17.6725 4.39258C17.8697 4.39258 18.0607 4.42758 18.2454 4.49757C18.4303 4.56757 18.594 4.67888 18.7364 4.8315L19.9376 6.04768C20.0903 6.19014 20.199 6.35407 20.2639 6.53947C20.3288 6.72487 20.3613 6.91027 20.3613 7.09568C20.3613 7.29354 20.3275 7.4823 20.26 7.66197C20.1925 7.8418 20.085 8.00606 19.9376 8.15474L6.96949 21.1133H3.64059ZM15.7938 8.96004L15.1843 8.32883L16.4251 9.56961L15.7938 8.96004Z"
          fill="url(#paint0_linear_11788_10755)"
        />
        <path
          d="M5.60677 2.42383L6.74737 5.21751L9.54106 6.35811L6.74737 7.49872L5.60677 10.2924L4.46617 7.49872L1.67249 6.35811L4.46617 5.21751L5.60677 2.42383Z"
          fill="url(#paint1_linear_11788_10755)"
        />
        <path
          d="M18.3923 16.1867L19.1914 18.144L19.25 18.2875L19.3934 18.3461L21.3508 19.1452L19.3934 19.9444L19.25 20.0029L19.1914 20.1464L18.3923 22.1037L17.5931 20.1464L17.5346 20.0029L17.3911 19.9444L15.4338 19.1452L17.3911 18.3461L17.5346 18.2875L17.5931 18.144L18.3923 16.1867Z"
          stroke="url(#paint2_linear_11788_10755)"
          stroke-width="0.737679"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_11788_10755"
          x1="12.001"
          y1="4.39258"
          x2="12.001"
          y2="21.1133"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#25C1F2" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11788_10755"
          x1="5.60677"
          y1="2.42383"
          x2="5.60677"
          y2="10.2924"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#25C1F2" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11788_10755"
          x1="18.3923"
          y1="15.2109"
          x2="18.3923"
          y2="23.0795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#25C1F2" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};
